import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ORDERING_CHOICES, search, sort } from 'ducks/memberlist';

import { gettext } from 'utils/text';
import reverseUrl from 'utils/urls';
import ArenaBase from '../ArenaBase';

const mapStateToProps = (state) => ({
    query: state.query,
    ordering: state.ordering,
    filterChoices: state.choices,
    selectedFilterKey: state.filterKey,
});

const mapDispatchToProps = (dispatch) => ({
    search: (query) => dispatch(search(query)),
    sort: (value) => dispatch(sort(value)),
});

@connect(mapStateToProps, mapDispatchToProps)
class MemberListHeader extends ArenaBase {
    static propTypes = {
        query: PropTypes.string.isRequired,
        ordering: PropTypes.string.isRequired,
        search: PropTypes.func.isRequired,
        sort: PropTypes.func.isRequired,
    };

    state = {
        query: '',
    };

    render() {
        const isLoggedIn = DJ_CONST.user !== null;
        const buttonUrl = isLoggedIn ? reverseUrl('trafo_application_mentoroverview') : reverseUrl('trafo-register');
        const buttonText = isLoggedIn ? gettext('Mentors') : gettext('Join Trafo');

        return (
            <div className="arena__header">
                <div className="arena__header__title">
                    <h2>{gettext('Members')}</h2>
                </div>
                {this.renderSort(ORDERING_CHOICES.choices)}
                {this.renderSearch()}
                <a className="btn btn-primary mb-0 border-0" href={buttonUrl}>
                    {buttonText}
                </a>
            </div>
        );
    }
}

export default MemberListHeader;



// WEBPACK FOOTER //
// ./src/components/medlemmer/MemberListHeader.js